import { ICopperPipingRequest } from '../utils/entities/interface';
import { Pagination } from './booking';
import { get } from './https';

interface CopperPipingRequestsResponse {
  status: boolean;
  data: ICopperPipingRequest[];
  count: number;
  pagination: Pagination;
}

const GETCopperPipingRequests = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
  sortField = '',
  sortOrder = 'DESC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}): Promise<CopperPipingRequestsResponse> => {
  // Initialize the base URL with COPPER_PIPING type
  let url = `/api/v1/admin/enquiry-list?limit=${limit}&page=${page}&type=COPPER_PIPING`;

  // Conditionally add search parameter if provided
  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  // Conditionally add sortField and sortOrder if they are provided
  if (sortField && sortField !== 'name') {
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    url += `&sortOrder=${sortOrder}`;
  }

  // Fetch the response
  const response = await get(url);

  if (response.status == 200) {
    return response.data; // Return the copper piping data
  } else {
    throw new Error('Failed to fetch copper piping requests');
  }
};

export { GETCopperPipingRequests };
